<template>
  <SogCardActionButton
    :id="_id"
    ref="obj"
    mdi-icon="mdi-dots-vertical"
    :disabled="disabled"
    :tooltip="tooltip"
    style="align-self: flex-end"
    class="oles"
    @click="onMore"
  >
    <ContextMenuComponent
      ref="_menu"
      :items="items"
      :before-item-render="beforeItemRender"
      :before-open="beforeOpen"
      class="oles"
      @select="onSelect"
    />
    <div v-show="false">
      <svg
        v-for="svg in items.filter(t=>t.svgIcon)"
        :id="svg.id"
        :key="svg"
        width="24"
        height="24"
        style="align-self: center;margin-right: 3px"
      >
        <path :d="svg.svgIcon" />
      </svg>
    </div>
  </SogCardActionButton>
</template>

<script setup lang="ts">
import {ref} from "vue";
import {DropDownButtonComponent} from "@syncfusion/ej2-vue-splitbuttons";
import getGuid from "@/shared/utils/getGuid";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {ContextMenuComponent, MenuEventArgs} from "@syncfusion/ej2-vue-navigations";
import {enableRipple} from '@syncfusion/ej2-base';

enableRipple(true);


interface Props {
  disabled?: boolean | string
  tooltip?: string
  items: IActionItem[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    disabled: false, tooltip: undefined
  }
)

const _emits = defineEmits<{ (e: 'select', id: string): boolean }>();


const obj = ref<InstanceType<typeof DropDownButtonComponent> | null>(null)
const _menu = ref<InstanceType<typeof ContextMenuComponent> | null>(null)
const _id = ref(getGuid())


export interface IActionItem {
  id: string,
  text: string,
  mdiIcon?: string
  svgIcon?: string,
  visible: boolean,
}


const focus = () => {
  obj.value?.focus();
}

defineExpose({
  focus
})

function onMore() {
  const a = document.getElementById(_id.value);
  if (!a)
    return
  const rect = a.getBoundingClientRect();
  _menu.value.open(rect.bottom, rect.left)
}

function beforeOpen() {
  const array: string[] = []
  props.items.filter(t => t.visible).map(t => array.push(t.text))
  _menu.value.showItems(array)
  array.length = 0;
  props.items.filter(t => !t.visible).map(t => array.push(t.text))
  _menu.value.hideItems(array)
}

function beforeItemRender(args: any) {

  /*
      <svg
      width="24"
      height="24"
    >
      <path :d="mdiAccount" />
    </svg>

  * */
  /*
  const svg = document.createElement('svg');
  const path = document.createElement('path');
  path.setAttribute("d",mdiAccount)

  svg.appendChild(path)
*/

  const a = document.getElementById(args.item.id);

  args.element.innerText = ""


  const div = document.createElement("div")
  div.setAttribute("class", "sog-card-action-more-button");
  div.setAttribute("style", "display:flex; ");

  if (a) {
    div.appendChild(a)
  }
  const text = document.createElement("span")
  text.innerText = args.item.text
  div.appendChild(text)
  args.element.appendChild(div)

}

function onSelect(event: MenuEventArgs) {
  if (event.item.id) {
    _emits('select', event.item.id)
  }
}

</script>

<style>

path {
  fill: currentColor;
}

.sog .sog-card-action-more-button {
  color: #22d3ee;
//background: red;
}

.sog .sog-card-action-more-button:hover {
  /*
  background-color: #22d3ee;
  border: 1px solid #6b7280;
  */
  color: #fff;
}

</style>
